import React from 'react'
import { Grid } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import GlobalAlert from '@src/components/GlobalAlert'
import useFormikHelper from '../useFormikHelper'
import { useRouter } from '@src/routes'
import { ActiveLinkType } from '../ProductsConfiguration'

enum ValidationButtonType {
  AddOligo = 'addOligo',
  NextStep = 'nextStep',
}

const ERROR_MESSAGES = {
  ADD_ITEM: (
    <FormattedMessage
      id="SINGLE_PRODUCT_ENTRY_PAGE_LEVEL_ERROR_MESSAGE"
      defaultMessage="Please correct error(s) before adding a new item."
    />
  ),
  NEXT_STEP: (
    <FormattedMessage
      id="CONF_DNAPLATES_ERROR_STEP2"
      defaultMessage="Please correct the error(s) before proceeding to the next step."
    />
  ),
} as const

const PageError: React.FC = () => {
  const { allValues, selectedOligoValues } = useFormikHelper()
  const { query } = useRouter()

  const hasOligoError = allValues.oligoList.some(
    (oligo) => oligo.displayPageError
  )

  const isConfirmOrderStep = query.activeLink === ActiveLinkType.ConfirmOrder
  const isMultipleEntryLink = query.activeLink === ActiveLinkType.MultipleEntry
  const displayStep2PageError = hasOligoError && isConfirmOrderStep
  const multipleEntryLinkHasError =
    allValues?.displayPageError && isMultipleEntryLink

  const shouldDisplayError =
    selectedOligoValues?.displayPageError ||
    displayStep2PageError ||
    multipleEntryLinkHasError

  if (!shouldDisplayError) {
    return null
  }

  const getErrorMessage = () => {
    const isAddOligoError =
      (selectedOligoValues?.displayPageError || displayStep2PageError) &&
      allValues.activeValidationButton === ValidationButtonType.AddOligo

    if (isAddOligoError) {
      return ERROR_MESSAGES.ADD_ITEM
    }

    return ERROR_MESSAGES.NEXT_STEP
  }

  return (
    <Grid item xs={12}>
      <GlobalAlert severity="error">{getErrorMessage()}</GlobalAlert>
    </Grid>
  )
}

export default PageError
